// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner__spinner___3sFKA","body":"Spinner__body___32X8N"};